// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionList_wrapper__0wgmB"};